import { useRouter } from 'next/router'
import React from 'react'

import events from 'src/events'

const useTrackPage = () => {
  const location = useRouter()

  React.useEffect(() => {
    events.pageViewed()
  }, [location.asPath])

  return null
}

export default useTrackPage
